module.exports = __webpack_public_path__ + "img/banner_contact_us.20ddfb9a.png";